import React from "react";
import { Html } from "@react-three/drei";

interface BodyLabelProps {
  name: string;
  /** Posição Y local no topo da esfera (raio). */
  sphereRadius: number;
}

/**
 * Legenda com fonte fixa (12px) e linha fixa ligando o rótulo à esfera.
 * Sem distanceFactor — o tamanho na tela não muda com o zoom.
 */
export function BodyLabel({ name, sphereRadius }: BodyLabelProps) {
  return (
    <Html
      position={[0, sphereRadius, 0]}
      style={{ pointerEvents: "none" }}
      zIndexRange={[100, 0]}
    >
      <div className="tls-astro-label-anchor">
        <div className="tls-astro-label">{name}</div>
        <div className="tls-astro-leader-line" aria-hidden />
        <div className="tls-astro-leader-dot" aria-hidden />
      </div>
    </Html>
  );
}
